/**
 * Configuración → Canales (GKTIBO-125).
 *
 * ## Por qué los canales salieron del alta
 *
 * Eran el paso 2 y bloqueaban todo lo demás: el dueño tenía que cablear
 * WhatsApp Business **antes de haber visto a su bot contestar una sola vez**.
 * Es pedirle que apueste a ciegas, y con los datos de Meta a mano o sin ellos.
 *
 * Ahora es el segundo momento: el alta termina con el bot sabiendo atender, y
 * conectarlo a un canal se hace acá, cuando el dueño tenga los datos.
 *
 * ## Lo que NO se reescribió
 *
 * `PasoDeCanales` ya sabe conectar Telegram y WhatsApp, con sus validaciones y
 * sus estados a medias. Se **mueve**, no se duplica: dos formularios que
 * escriben el mismo canal es cómo se separan (L34).
 *
 * ## Qué falta de esta pantalla
 *
 * Es la primera pantalla de configuración que existe — hasta hoy el panel
 * tenía `/users` y el detalle del tenant, nada más. La barra lateral nombra
 * las secciones que vienen; las que todavía no existen **no se dibujan como
 * enlaces muertos**, porque un menú que no lleva a ningún lado se lee como que
 * el producto está roto.
 */

import { useQuery } from '@tanstack/react-query';
import { AppShell } from '../../components/AppShell';
import { useTenantContext } from '../../hooks/useTenantContext';
import { api } from '../../lib/api.ts';
import { PasoDeCanales } from '../alta/PasoDeCanales';
import { configuracion } from './textos-configuracion';

export function PaginaDeCanales() {
  const { activeTenantId } = useTenantContext();

  const { data, refetch } = useQuery({
    queryKey: ['onboarding-status', activeTenantId],
    queryFn: () => api.tenants.getOnboardingStatus(activeTenantId as string),
    enabled: Boolean(activeTenantId),
  });

  if (!activeTenantId) {
    return (
      <AppShell>
        <div className="configuracion" data-testid="configuracion-sin-tenant">
          <p className="text-sm text-content-secondary">{configuracion.sinNegocio}</p>
        </div>
      </AppShell>
    );
  }

  return (
    <AppShell>
      <div className="configuracion" data-testid="configuracion-canales">
        <nav className="configuracion-lateral" aria-label={configuracion.titulo}>
          <p className="configuracion-lateral-titulo">{configuracion.titulo}</p>
          <span className="configuracion-item es-actual" aria-current="page">
            {configuracion.canales}
          </span>
        </nav>

        <div className="configuracion-cuerpo">
          <h1 className="card-title">{configuracion.canales}</h1>
          <p className="configuracion-bajada">{configuracion.bajadaDeCanales}</p>

          {data && (
            <PasoDeCanales
              canales={data.channels}
              tenantId={activeTenantId}
              valor={{}}
              // Tras guardar se vuelve a PREGUNTAR en vez de creerle al
              // navegador: la verdad del estado siempre viene del servidor.
              onGuardado={() => void refetch()}
            />
          )}

          <p className="configuracion-mientras">{configuracion.mientrasTanto}</p>
        </div>
      </div>
    </AppShell>
  );
}
